var exports = {
  "a": "Button_0__JD6IEU",
  "J": "Octicon_0__tzn7s5",
};

module.exports = exports;
